import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { showGeoComplyPopupAction } from '../actions';

export const useInitialCall = ({ setSDK, setShowOverlay, downloadSDK, geolocationType, useTransparentPopup }) => {
    const dispatch = useDispatch();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const closePopups = useSmartClosePopups();

    return useCallback(async () => {
        // initial call to understand if check is needed at all
        const response = await validateGeolocation(null, null, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};
        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const nextCheckIn = Number(geolocationData.nextCheckIn);

        if (!sessionValidationData.SessionValidationByGeolocationData) {
            // no geofencing -- go straight to end.
            setShowOverlay(false);
            return;
        }

        if (nextCheckIn === 0) {
            // check will be done now, so show overlay
            setShowOverlay(true);
        }

        publicEventsAPIService.trigger('geofencing-init', { geolocationType });

        try {
            const sdk = await downloadSDK();

            setSDK(sdk);
        } catch (error) {
            publicEventsAPIService.trigger('geofencing-error', { error });

            dispatch(showGeoComplyPopupAction({
                title: 'playtech.mobile.system.geocomply.popups.sdkNotAvailable.title',
                content: 'playtech.mobile.system.geocomply.popups.sdkNotAvailable.content',
                isModal: true,
                buttons: [
                    {
                        onClick: () => closePopups(),
                        text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                        color: 'negative'
                    },
                    {
                        onClick: onRefresh,
                        text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                        color: 'info'
                    }
                ],
                useTransparentPopup
            }));

            setShowOverlay(false);
        }
    }, [
        setSDK,
        setShowOverlay,
        downloadSDK,
        geolocationType,
        useTransparentPopup,
        dispatch,
        closePopups,
        onRefresh
    ]);
};
